import { render, staticRenderFns } from "./SimpleProductsMobile.vue?vue&type=template&id=312dc79a&scoped=true"
import script from "./SimpleProductsMobile.vue?vue&type=script&lang=js"
export * from "./SimpleProductsMobile.vue?vue&type=script&lang=js"
import style0 from "./SimpleProductsMobile.vue?vue&type=style&index=0&id=312dc79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dc79a",
  null
  
)

export default component.exports